import React, {Component} from 'react';
import {gpn} from "../GPN"
import Icon from "../sections/MUI/Icon";


class BottomNav extends Component {

    constructor() {
        super();
        this.buttons = [];

    }

    state = {
        path: "/"
    };

    componentDidMount() {
        this.setState({path: this.props.path});
        let p = this.props.path;
        this.setButtons(p);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.setState({path: this.props.path});
            let p = this.props.path;
            this.setButtons(p);
        }
    }

    setButtons(p = "/") {
        this.buttons = [
            {t: "خانه", i: "home", p: "/", ia: p === "/"},
            {t: "تسهیلات", i: "coin", p: "/facilities", ia: p === "/facilities"},
            {t: "سفارشات", i: "sort", p: "/orders", ia: p === "/orders"},
            {t: "پرداخت‌ها", i: "money-bill", p: "/payments", c: "", ia: p === "/payments"},
            {t: "پروفایل", i: "user", p: "/profile", ia: p === "/profile"}
        ];
    }

    render() {
        if (this.state.path === "/login" || this.buttons.length === 0) {
            return null;
        }
        return (
            <div className="bottom-nav">
                {
                    this.buttons.map((b, i) =>
                        <div className="col" key={"bnitem" + i}>
                            <div className={b.ia ? "btn active" : "btn"}
                                 onClick={() => this.props.navigate(b.p)}>
                                <div className="icon">
                                    <Icon i={b.i}/>
                                </div>
                                <div className="title">{b.t}</div>
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
}

export default gpn(BottomNav);